<template>
  <div class="help">
    <div class="container">
      <el-page-header class="nav" @back="$router.go(-1)" content="帮助中心">
      </el-page-header>

      <el-empty
        description="暂无帮助文档"
        :image-size="200"
        v-if="list.length == 0"
      ></el-empty>

      <el-row :gutter="20" v-else>
        <el-col :span="4">
          <div class="box left">
            <p
              class="item"
              :class="{ active: activeId == item.docsId }"
              v-for="item in list"
              :key="item.docsId"
              @click="activeId = item.docsId"
            >
              {{ item.title }}
            </p>
          </div>
        </el-col>
        <el-col :span="20"
          ><div class="box right" v-html="content"></div
        ></el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { docList, docDetail } from "@/api/helper";
export default {
  data() {
    return {
      list: [],
      activeId: null,
      content: "",
    };
  },
  created() {
    this.getList();
  },
  watch: {
    activeId(val) {
      this.getDetail(val);
    },
  },
  methods: {
    getList() {
      this.$loading.show();
      docList().then(({ code, data, msg }) => {
        this.$loading.hide();
        if (code == 0) {
          this.list = data;
          this.activeId = data[0].docsId;
        } else {
          this.$message.error(msg);
        }
      });
    },
    getDetail(docsId) {
      this.$loading.show();
      docDetail(docsId).then(({ code, data, msg }) => {
        this.$loading.hide();
        if (code == 0) {
          this.content = data.content;
        } else {
          this.$message.error(msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.help {
  padding-bottom: 30px;
  background-color: rgb(248, 248, 248);
  ::v-deep .el-page-header {
    margin: 30px 0;
    .el-page-header__content {
      font-size: 14px;
    }
  }
  .box {
    text-align: left;
    background-color: #fff;
    &.right {
      padding: 40px 20px;
    }
    .item {
      padding: 10px 20px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      transition: all 0.3s ease;
      cursor: pointer;
      &:hover,
      &.active {
        color: #fff;
        background-color: teal;
      }
    }
  }
}
</style>